import {
  SYSTEM_ERROR_OCCURED,
  CLEAN_ERRORS
} from "../actions/types/serviceNotificationActionTypes";
import { TOGGLE_CONFIGURATION_MODE } from "../actions/types/configurationActionTypes";

export default function orderReducer(state = {}, action) {
  if (action.type.endsWith("_SUCCEED")) {
    state.lastServiceError = null;
  }

  switch (action.type) {
    case SYSTEM_ERROR_OCCURED: {
      state.lastServiceError = action.error.errorKey;
      return Object.assign({}, state);
    }
    case CLEAN_ERRORS:
    case TOGGLE_CONFIGURATION_MODE: {
      state.lastServiceError = null;
      return Object.assign({}, state);
    }
    default: {
      return Object.assign({}, state);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/serviceNotificationReducer.js